//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {analysis} from "@/constants";
import analyzer from "../../analysis";

export default {
  name: "FieldAnalysis",
  props: {
    statistics: {
      type: Object
    }
  },

  computed: {
    balance() {
      let balance = analyzer.check_balance(this.statistics);
      if (balance.severity === analysis.FATAL) {
        return {
          issue: `Too big of a difference between label with more data ${balance.max.key}:
          ${balance.max.docCount} and with the lowest count ${balance.min.key}: ${balance.min.docCount}`,
          solution:
              "annotate more document that contain the lowest count label and less of the high count label",
          severity: analysis.FATAL
        };
      }

      if (balance.severity === analysis.WARNING) {
        return {
          issue: `Too big of a difference between label with more data ${balance.max.key}:
          ${balance.max.docCount} and with the lowest count ${balance.min.key}: ${balance.min.docCount}`,
          solution:
              "annotate more document that contain the lowest count label and less of the high count label",
          severity: analysis.WARNING
        };
      }

      return null;
    },

    cardinality() {
      let cardinality = analyzer.check_cardinality(this.statistics);
      if (cardinality.severity === analysis.FATAL) {
        return {
          issue: "Total number of documents with field is too low",
          solution: "annotate more document with this field",
          severity: analysis.FATAL
        };
      } else if (cardinality.severity === analysis.WARNING) {
        return {
          issue: "Total number of documents with field is low",
          solution: "annotate more document with this field",
          severity: analysis.WARNING
        };
      }

      return null;
    }
  }
};
